export default __webpack_public_path__ + "static/media/circle.b54ffba6.jpg";